// extracted by mini-css-extract-plugin
export default {"price-form":"FerryForm_price-form__CU9cD","price-form__toolbar":"FerryForm_price-form__toolbar__-ER9j","price-form--edit":"FerryForm_price-form--edit__AVTyO"};